// extracted by mini-css-extract-plugin
export default {"container":"CategoryCard_container__5-rpm"};